import IncidencesService from 'src/services/incidences'

export default {
  totalOccurrences (payload) {
    const promise = IncidencesService.totalOccurrences(payload)

    promise.then(data => {
      this.occurrences = data
    })

    return promise
  },
  answersByOccurrences (payload) {
    const promise = IncidencesService.answersByOccurrences(payload)

    promise.then(data => {
      this.answers = data
    })

    return promise
  },
  answersByOccurrencesExcel (payload) {
    const promise = IncidencesService.answersByOccurrencesExcel(payload)

    promise.then(data => {
      this.items = data
    })

    return promise
  }
}
